import React ,{ useState, useEffect } from 'react';
import { CircularProgress, Grid } from '@mui/material';
import { Box } from '@mui/material'
import { Typography  } from '@mui/material'
import { useStyles } from "./styles";
import { Stack } from '@mui/material';
import { Avatar } from '@mui/material'
import { useAuth } from "../../../hooks/useAuth"
import { TextField } from '@mui/material'
import { useQuery, useMutation } from "react-query";
import { listCompany } from '../../../services/company'
import { putCompany } from '../../../services/company'
import { useToast } from '../../../hooks/useToast';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import {getInitials} from '../../../utils/getInitials';
import jwt_decode from 'jwt-decode';
import { SaveButton } from '../../../components/SaveButton';

type MyCompany = {
    cnpj : string,
    name: string,
    companyBasePath: string
};

type DecodedToken = {
    user_id: number;
    email: string;
    name: string;
    company_id: number;
    isAdmin: boolean;
    isOperator: boolean;
    iss: string;
    type: string;
    exp: number;
    iat: number;
}

const schema = Yup.object().shape({
    cnpj: Yup.string().required('O CNPJ é obrigatorio'),
    name: Yup.string().required('O nome é obrigatorio'),
});

export function Company() {
    const [data, setData] = useState<MyCompany>();
    const styles = useStyles();
    const { user, token } = useAuth();
    const [localUser, setLocalUser] = useState({name : '', email: ''})
    const toast = useToast();
    const decodedToken : DecodedToken = jwt_decode(token);
    const { isAdmin, isOperator } = decodedToken;
    //const [saveButton, setSaveButton] = useState(false)

    const getCompany = useQuery("getCompany", async () => {
        const response : any = await listCompany();
        console.log('response: ',response.data)
        setData(response.data)
        return response
    }, {staleTime: 2000, cacheTime: 10});

    const updateCompany = useMutation(
        async (data : MyCompany) => {
          const response = await putCompany(data);
          return response;
        },
        {
          onSuccess: () => {
            toast.show("Loja atualizada com sucesso!", { severity: "success" });
            //setSaveButton((prev) => !prev)
            console.log(getCompany)
          },
          onError: () => {
            toast.show("Falha ao atualizar a loja!", { severity: "error" });
            console.log(getCompany)
          },
        }
      );

    const onSubmit = async (values : any, actions: any)  => {
        console.log('actions: ',actions)
        //setSaveButton((prev) => !prev)
        try {
            await updateCompany.mutateAsync(values);
        }catch (err) {
            console.log({ err });
        }
    }
   
    useEffect(() => {
        setLocalUser({name: user.name, email: user.email})
    }, [setLocalUser, user]);

    if (!data) {
        return (
            <Grid container spacing={2} sx={{height: '28rem'}}>
                <Grid item xs={9} lg={5} md={8} sm={12} className={styles.gridCircularProgress}>
                    <CircularProgress size={24} />
                </Grid>
            </Grid>
        );
    }
  return (
    <Grid container spacing={2}>
        <Grid item xs={9} lg={5} md={8} sm={12}>
            <Stack>
               <Formik
                    initialValues={data}
                    onSubmit={onSubmit}
                    validationSchema={schema}
                    render={({values, handleChange, errors, isSubmitting})=>(
                        <Form noValidate>
                            <Box>
                                <Typography variant="h4" noWrap className={styles.titulo}>
                                    Empresa
                                </Typography>
                                <Typography noWrap className={styles.subTitulo}>
                                    Veja as informações da sua empresa.
                                </Typography>
                            </Box>
                            <Grid xs={3} md={8} sm={12} className={styles.gridAvtItm}>
                                <Grid sx={{display: 'flex'}}>
                                    <Grid item sx={{marginRight: '1rem'}}>
                                        <Avatar className={styles.avatar}>{getInitials(localUser.name)}</Avatar>
                                    </Grid>
                                    <Grid item className={styles.itemText}>
                                        <Box>
                                            <Typography variant="h6" gutterBottom className={styles.nome}>
                                                {localUser.name}
                                            </Typography>
                                            <Typography variant="body1" align="center" className={styles.email}>
                                                {localUser.email}
                                            </Typography>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid container spacing={2} sx={{marginBottom: '15px'}}>
                                <Grid item xs={12}>
                                    <TextField sx={{width:'100%'}}
                                        name="cnpj"
                                        label="CNPJ"
                                        variant="outlined"
                                        value={values.cnpj}
                                        onChange={handleChange}
                                        error={!!errors.cnpj}
                                        helperText={!!errors.cnpj ? errors.cnpj : null}
                                        disabled={!isAdmin && isOperator}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField sx={{width:'100%'}}
                                        name="name"
                                        label="Nome"
                                        variant="outlined"
                                        value={values.name}
                                        onChange={handleChange}
                                        error={!!errors.name}
                                        helperText={!!errors.name ? errors.name : null}
                                        disabled={!isAdmin && isOperator}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField sx={{width:'100%'}}
                                        name="companyBasePath"
                                        label="Path"
                                        variant="outlined"
                                        value={values.companyBasePath}
                                        onChange={handleChange}
                                        disabled
                                    />
                                </Grid>
                            </Grid>
                            <Box sx={{display: 'flex', justifyContent: 'flex-end'}}>
                                <SaveButton
                                    titulo='Salvar'
                                    isSubmitting={isSubmitting}
                                />
                            </Box>
                        </Form>
                    )}
                />
            </Stack>
        </Grid>
    </Grid>
  );
}